﻿

// ------------------------------------------------------------------------------------------------
// -- Class: Email   ------------------------------------------------------------------------------
// -- File : email.js -----------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
export { Email };

/**
 * Class Email
 */
const Email = function () {

    //Define this
    var myEmail = this;

    // -- begin public variable -------------------------------------------------------------------

    // Datable notification info
    this.datatableNotificationInfo = null;

    // -- end public variable ---------------------------------------------------------------------

    // -- begin private variable ------------------------------------------------------------------

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Init email
     */
    this.InitEmail = function () {
        // -- Init datatable notification info ----------------------------------------------------

        // -- init column def --
        var columnDefNotificationInfo = [];

        // id_email_msg
        columnDefNotificationInfo.push({
            'data': 'id_email_msg',
            'type': 'readonly',
            'visible': false,
            'render': function (data, type, row) {
                if (data) {
                    return row.id_email_msg
                } else {
                    return row.id_email_msg = '';
                }
            },
        });
        // id_entity
        columnDefNotificationInfo.push({
            'data': 'id_entity',
            'type': 'readonly',
            'visible': false,
            'render': function (data, type, row) {
                if (data) {
                    return row.id_entity
                } else {
                    return row.id_entity = '';
                }
            },
        });
        // name_entity
        columnDefNotificationInfo.push({
            'data': 'name_entity',
            'type': 'readonly',
            'visible': false,
            'render': function (data, type, row) {
                if (data) {
                     return row.name_entity
                } else {
                    return row.name_entity = '';
                }
            },
        });
        // id_user_send
        columnDefNotificationInfo.push({
            'data': 'id_user_send',
            'type': 'readonly',
            'visible': false,
            'render': function (data, type, row) {
                if (data) {
                        return row.id_user_send
                } else {
                    return row.id_user_send = '';
                }
            },
        });
        //// User send name
        //columnDefNotificationInfo.push({
        //    'data': 'user_send_name',
        //    'title': 'Utilizador',
        //    'name': 'Utilizador',
        //    'label': 'Utilizador',
        //    'type': 'readonly',
        //    'orderable': false,
        //    'className': 'dt-body-center dt-occurrence-event',
        //    'width': '60px'
        //});
        // state_description
        columnDefNotificationInfo.push({
            'data': 'state_description',
            'title': 'Estado',
            'name': 'Estado',
            'label': 'Estado',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-event',
            'width': '60px',
            'render': function (data, type, row) {
                if (data) {
                    if (data == 'Mensagem enviada com sucesso')
                        return row.state_description = "Successo"
                    else
                        return row.state_description = "Erro"
                } else {
                    return row.state_description = 'Sem dados';
                }
            },
        });
        // Email to
        columnDefNotificationInfo.push({
            'data': 'to_email',
            'title': 'Para',
            'name': 'Para',
            'label': 'Para',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-event dt-to-email',
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 15)
                        return '<span id="to_email">' + row.to_email.substring(0, 15) + "..." +'</span>' 
                    else
                        return '<span id="to_email">' + row.to_email + '</span>'
                } else {
                    return row.to_email = '<span id="to_email">Sem dados</span>';
                }
            },
            'width': '60px'
        });
        // Email cc
        columnDefNotificationInfo.push({
            'data': 'cc_email',
            'title': 'Cc',
            'name': 'Cc',
            'label': 'Cc',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-event dt-cc-email',
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 15)
                        return '<span id="cc_email">' + row.cc_email.substring(0, 15) + "..." + '</span>'
                    else
                        return '<span id="cc_email">' + row.cc_email + '</span>'
                } else {
                    return row.cc_email = '<span id="cc_email">Sem dados</span>';
                }
            },
            'width': '60px'
        });
        // Email bcc
        columnDefNotificationInfo.push({
            'data': 'bcc_email',
            'title': 'Bcc',
            'name': 'Bcc',
            'label': 'Bcc',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-event dt-bcc-email',
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 15)
                        return '<span id="bcc_email">' + row.bcc_email.substring(0, 15) + "..." + '</span>'
                    else
                        return '<span id="bcc_email">' + row.bcc_email + '</span>'
                } else {
                    return row.bcc_email = '<span id="bcc_email">Sem dados</span>';
                }
            },
            'width': '60px'
        });
        // Subject
        columnDefNotificationInfo.push({
            'data': 'subject',
            'title': 'Assunto',
            'name': 'Assunto',
            'label': 'Assunto',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-event dt-subject-email',
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 20)
                        return '<span id="subject">' + row.subject.substring(0, 20) + "..." + '</span>'
                    else
                        return '<span id="subject">' + row.subject + '</span>'
                } else {
                    return row.subject = '<span id="subject">Sem dados</span>';
                }
            },
            'width': '60px'
        });
        // msg_body
        columnDefNotificationInfo.push({
            'data': 'msg_body',
            'title': 'Mensagem',
            'name': 'Mensagem',
            'label': 'Mensagem',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-event dt-body-email',
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 20)
                        return '<span id="msg_body">' + row.msg_body.substring(0, 20) + "..." + '</span>'
                    else
                        return '<span id="msg_body">' + row.msg_body + '</span>'
                } else {
                    return row.msg_body = '<span id="msg_body">Sem dados</span>';
                }
            },
            'width': '60px'
        });
        // cod_state
        columnDefNotificationInfo.push({
            'data': 'cod_state',
            'type': 'readonly',
            'visible': false,
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 20)
                        return '<span id="cod_state">' + row.cod_state.substring(0, 20) + "..." + '</span>'
                    else
                        return '<span id="cod_state">' + row.cod_state + '</span>'
                } else {
                    return row.cod_state = '<span id="cod_state">Sem dados</span>';
                }
            },
        });
        // -- Table definition --
        myEmail._datatableNotificationInfo = $('#id-modal-email-body-msg-state-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhuma notificação efectuada',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": true,
            "info": false,
            "autoWidth": false,
            "scrollY": $('#id-offcanvas-occurrence-detail-event-table-zone').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "ordering": false,
            "columns": columnDefNotificationInfo,
            "select": false,
            "name": "email_msg_state",
            "rowId": 'id_email_msg',
            "iDisplayLength": 10
        });

        // Event on click to remove data from datatable
        myEmail._datatableNotificationInfo.on('draw', function () {

            //$('[data-toggle="tooltip"]').tooltip();   

            // Event goto element detail
            $('#id-modal-email-body-msg-state-table td').unbind().mouseover(function () {
                var ListEmails = app.sgs.Occurrences._emailsArraytooltip;
                $(this).append($('#id-tooltipemail'));
                var idElement = parseInt(this.parentElement.id);
                var field = $(this).children()[0].id;
                $('#id-tooltipemail').css({ 'display': 'initial' })
                var Data = ListEmails.find(c => c.id_email_msg === idElement);

                switch (field) {
                    case "to_email":
                        if (Data.to_email.length > 20) 
                            $('#id-tooltipemail').html(Data.to_email);
                        else
                            $('#id-tooltipemail').css({'display':'none'});
                        break;
                    case "bcc_email":
                        if (Data.bcc_email.length > 20)
                            $('#id-tooltipemail').html(Data.bcc_email);
                        else
                            $('#id-tooltipemail').css({ 'display': 'none' })
                        break;
                    case "cc_email":
                        if (Data.cc_email.length > 20)
                            $('#id-tooltipemail').html(Data.cc_email);
                        else
                            $('#id-tooltipemail').css({ 'display': 'none' })
                        break;
                    case "subject":
                        if (Data.subject.length > 20)
                            $('#id-tooltipemail').html(Data.subject);
                        else
                            $('#id-tooltipemail').css({ 'display': 'none' })
                        break;
                    case "msg_body":
                        if (Data.msg_body.length > 20)
                            $('#id-tooltipemail').html(Data.msg_body);
                        else
                            $('#id-tooltipemail').css({ 'display': 'none' })
                        break;
                    case "id-tooltipemail":
                            $('#id-tooltipemail').css({ 'display': 'none' })
                        break;
                    default:
                        break;
                }

            });

            $('#id-modal-email-body-msg-state-table td').mouseleave(function () {
                $('#id_occurrence_event_detail').append($('#id-tooltipemail'));
                $('#id-tooltipemail').css({ 'display': 'none' });
            });

        });
    };

    this.CleanEmailForm = function () {
        // Clean form
        $('#id-modal-email-body-msg-definition-to').val('');
        $('#id-modal-email-body-msg-definition-cc').val('');
        $('#id-modal-email-body-msg-definition-bcc').val('');
        $('#id-modal-email-body-msg-definition-subject').val('');
        $('#id-modal-email-body-msg-definition-msg').val('');

        // Clean state table
        myEmail._datatableNotificationInfo.clear().draw();
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    // -- end private method ----------------------------------------------------------------------

	// -- begin event -----------------------------------------------------------------------------

	// -- end event -------------------------------------------------------------------------------
};